import React, { useState, useEffect, useRef } from 'react';
import Popup from 'reactjs-popup';
import '../../App.css';
import { fetchCertData } from '../../services/api.js';
import { confirmCertData } from '../../services/api.js';
import { submitCertCreate } from '../../services/api.js';
import { sendSACCode, verifySACCode } from '../../services/secure_accesscode';
import { fetchMemberData } from '../../services/api';
import { useNavigate } from 'react-router-dom';
import '../../styles/output.css';
import '../../styles/index.css';
import 'reactjs-popup/dist/index.css';
import './AppCert.css';


import { SideMenu, Header, TopMenu } from 'maxcu-shared-lib';
import menuItems from '../SideMenu/menuItems';


function AddCert() {
    const [certData, setCertData] = useState(null);
    const [certConfirmData, setCertConfirmData] = useState(null);
    const [certSubmitData, setCertSubmitData] = useState(null);
    const [error, setError] = useState(null);
    const [loading,setLoading] = useState(false)

    const [certOption,setCertOption] = useState('null');
    const [amount, setAmount] = useState('0.00');
    const [certTransferFunds, setCertTransferFunds] = useState('null');
    
    const [minBalModal, setIsMinBalModalOpen] = useState(false);
    const [bothModal, setIsBothModalOpen] = useState(false);
    const [nsfModal, setIsNsfModalOpen] = useState(false);
    const [agree, setAgree] = useState(false);
    
    const [message, setMessage] = useState({type: '',text: ''});
    const navigate = useNavigate();

    const [confirmModal, setIsConfirmModalOpen] = useState(false);
    const [modalStep, setModalStep] = useState('confirm'); // 'confirm', 'mfa-method', 'mfa-code'
    const [selectedMfaMethod, setSelectedMfaMethod] = useState('');
    const [mfaCode, setMfaCode] = useState('');
    const [mfaError, setMfaError] = useState('');
    const [memberInfo, setMemberInfo] = useState(null);
    const [selectedPhoneIndex, setSelectedPhoneIndex] = useState(null);
    const [isCollapsed, setIsCollapsed] = useState(false);

    const [mfaMethod, setMfaMethod] = useState(''); // New state for MFA method
    

    const depositAmountRef = useRef(null);

const getMemberData = async () => {
        const member_info = await fetchMemberData();
        if (member_info) {
            setMemberInfo(member_info);
        }
        else {
            console.error('No member data found');
        }
    };

function maskPhoneNumber(phone) {
      // phone should be a string of digits
      const digits = phone.replace(/\D/g, '');
      return `(***) ***-${digits.slice(-4)}`;
    }

    const getFilteredPhones = (phoneObj) => {
      if (!phoneObj) return [];
      const cellRaw = phoneObj.cell || '';
      const homeRaw = phoneObj.home || '';
      const cell = cellRaw.replace(/\D/g, '');
      const home = homeRaw.replace(/\D/g, '');

      // If both are empty, return empty array
      if (!cell && !home) return [];

      // If both exist and are the same, show only cell
      if (cell && home && cell === home) {
        return [['cell', cellRaw]];
      }

      // Otherwise, show both if they exist
      const result = [];
      if (cell) result.push(['cell', cellRaw]);
      if (home) result.push(['home', homeRaw]);
      return result;
    };

    const phoneEntries = memberInfo && memberInfo.phone_number
      ? getFilteredPhones(memberInfo.phone_number)
      : [];

    const handleSendSACCode = async (method) => {
        if (selectedPhoneIndex !== null && method) {
            const [label, phone] = phoneEntries[selectedPhoneIndex];
            const cleanPhone = phone.replace(/\D/g, ''); // Remove all non-digit characters
            try {
                await sendSACCode(cleanPhone, method);
                setModalStep('mfa-code');
            } catch (err) {
                setMfaError('Failed to send code. Please try again.');
            }
        }
    };

    const handleVerifySACCode = async () => {
        if (selectedPhoneIndex !== null && mfaCode.length === 6) {
            const [label, phone] = phoneEntries[selectedPhoneIndex];
            const cleanPhone = phone.replace(/\D/g, '');
            try {
                const result = await verifySACCode(cleanPhone, mfaCode);
                if (result.status === 'approved') { // Use strict comparison
                    handleCertSubmit();
                    setModalStep('confirm');
                    setMfaCode('');
                } else {
                    setMfaError('Invalid code. Please try again.');
                }
            } catch (err) {
                setMfaError('Verification failed. Please try again.');
            }
        } else {
            setMfaError('Please enter a 6-digit code.');
        }
    };

    const handleCertConfirm = async () => {
        setLoading(true);
        setMessage({ type: '', text: '' });

        try {
            const response = await confirmCertData({
                certType: certOption.split('.')[0],
                certDeposit: amount,
                certFundFrom: certTransferFunds.split('.')[0]
            });
            setCertConfirmData(response);
            // Check response for success/failure
            if (response) { // Adjust this condition based on your API response
                setLoading(false);  
                setMessage({
                    type: 'successConfirm',
                    text: 'Your certificate account '+response.certificate.name+' has been created!'
                });
            } else {
                setLoading(false); 
                setMessage({
                    type: 'error',
                    text: response || 'Certificate Creation could not be processed. Please try again.'
                });
            }
            
        } catch (error) {
            console.error('Error submitting donation:', error);
            setLoading(false); 
            setMessage({
                type: 'error',
                text: 'An error occurred while processing your request. Please try again.'
            });
        }
    };


    const handleAgreeChange = (e) => {
        setAgree(e.target.checked);
    };

    const handleCertSubmit = async () => {
        setLoading(true);
        setMessage({ type: '', text: '' });

        try {
            const response = await submitCertCreate({
                certType: certOption.split('.')[0],
                certDeposit: amount,
                certFundFrom: certTransferFunds.split('.')[0],
                certDivPost: certConfirmData.certificate.dividend_post
            });

            setCertSubmitData(response);
            // Check response for success/failure
            if (response) { // Adjust this condition based on your API response
                setLoading(false); 
                setMessage({
                    type: 'successSubmit',
                    text: 'Your certificate account '+response.certificate.name+' has been created!'
                });
            } else {
                setLoading(false); 
                setMessage({
                    type: 'error',
                    text: response || 'Certificate Creation could not be processed. Please try again.'
                });
            }
            
        } catch (error) {
            setLoading(false); 
            console.error('Error submitting certificate:', error);
            setMessage({
                type: 'error',
                text: 'An error occurred while processing your request. Please try again.'
            });
        }
    };

    const handleCertOption = (e) => {
        setCertOption(e.target.value);
    };
    
    const handleBlur = () => {
        if (amount === '' || amount === '0') {
            setAmount('0.00'); // Default when empty
        } else if (!amount.includes('.')) {
            setAmount(amount + '.00'); // Append `.00` if no decimal
        } else {
            const parts = amount.split('.');
            if (parts[1].length === 0) {
                setAmount(parts[0] + '.00'); // If they typed ".", fix cents
            } else if (parts[1].length === 1) {
                setAmount(parts[0] + '.' + parts[1] + '0'); // Ensure 2 decimal places
            }
        }
    };

    const handleCertTransferFunds = (e) => {
        setCertTransferFunds(e.target.value);
    };

    const handleAdequateFunds = () => {
        const balance = parseFloat(certTransferFunds.split('.')[1]);
        let minBal='0.00';
        Object.entries(certData.certificates).map(([key ,data], index) => (
            certOption.split('.')[1] === data.type && (
              minBal = parseFloat(data.min_opening_balance_str)
            )
        ))
        if (parseFloat(amount) >= balance && parseFloat(amount) < minBal) {
            setIsBothModalOpen(true);
        } else if (parseFloat(amount) > balance && parseFloat(amount) >= minBal) {
            setIsNsfModalOpen(true);
        } else if (parseFloat(amount) <= balance && parseFloat(amount) < minBal) {
            setIsMinBalModalOpen(true);
        } else {
            handleCertConfirm();
        }
        
    };

    const handleAmountChange = (e) => {
        let value = e.target.value;

        // Remove non-numeric characters except "."
        value = value.replace(/[^\d.]/g, '');

        // Ensure only one decimal point
        const dotIndex = value.indexOf('.');
        if (dotIndex !== -1) {
            let beforeDecimal = value.slice(0, dotIndex); // Dollars
            let afterDecimal = value.slice(dotIndex + 1).replace(/[^0-9]/g, ''); // Cents (digits only)

            // Limit cents to two digits
            afterDecimal = afterDecimal.slice(0, 2);

            value = beforeDecimal + '.' + afterDecimal;
        }

        // Remove leading zeros unless it's "0."
        if (value.length > 1 && value.startsWith('0') && !value.startsWith('0.')) {
            value = String(Number(value));
        }
        setAmount(value);
    };

    // Add onFocus handler to select all text when input is focused
    const handleDepositAmountFocus = () => {
        if (depositAmountRef.current) {
            depositAmountRef.current.select();
        }
    };

    useEffect(() => {
        let isMounted = true;

        document.title = "Add Certificate | MAX Credit Union";
        const getData = async () => {
            try {
                const result = await fetchCertData();
                if (isMounted) {
                    setCertData(result);
                }
                const member_info = await fetchMemberData();
                if (isMounted) {
                    setMemberInfo(member_info);
                }
            } catch (error) {
                if (isMounted) {
                    setError(error);
                }
            }
        };
    
        getData();
        const handleResize = () => {
            if (window.innerWidth < 600) {
                setIsCollapsed(true);
            } else {
                setIsCollapsed(false);
            }
        };

        handleResize(); // Set initial state

        window.addEventListener('resize', handleResize);
        
        return () => {
            isMounted=false;
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (error) return <div>Error: {error.message}</div>;
    if (!certData) return <div className="throbber items-center justify-center"></div>;

    return (
        
        <div className="min-h-screen flex flex-col">
            <SideMenu menuItems={menuItems} />
            <div style={{ flex: 1 }} className={`${isCollapsed ? 'sb-thin' : 'sb-wide'}`}>
            <Header name="Add New Certificate" />
            {isCollapsed && <TopMenu />}
            { loading ? (
                <div className="throbber items-center justify-center"></div>
            ) : certData.btn_addcert === 'NO' ? (
               <div className="flex-grow flex flex-col items-center justify-center pt-24 space-y-8">
                    <h1>You are currently ineligible to Add an Account at this time. Please contact us at 334.260.2600 for more assistance</h1>
                </div>
            ) :message.text ? (
                message.type==='successConfirm' ? (
                    
                    <div className="flex-grow flex flex-col items-center justify-center pt-24 space-y-8">
                        <div style={{ width: '40%', margin: '0 auto' }}>
                            <table className="w-full border-collapse">
                                <tbody>
                                    {/* Placeholder for dynamic rows */}
                                    <tr className="bg-white">
                                        <td className="p-2">Initial Deposit</td>
                                        <td className="p-2">${certConfirmData.certificate.deposit}</td>
                                    </tr>
                                    <tr className="bg-gray-200">
                                        <td className="p-2">Funded From</td>
                                        <td className="p-2">{certConfirmData.certificate.funded_from_desc}</td>
                                    </tr>
                                    <tr className="bg-white">
                                        <td className="p-2">Rate</td>
                                        <td className="p-2">{certConfirmData.certificate.rate}%</td>
                                    </tr>
                                    <tr className="bg-gray-200">
                                        <td className="p-2">APY</td>
                                        <td className="p-2">{certConfirmData.certificate.apy}%</td>
                                    </tr>
                                    <tr className="bg-white">
                                        <td className="p-2">Maturity Date</td>
                                        <td className="p-2">{certConfirmData.certificate.maturity_date}</td>
                                    </tr>

                                    <tr className="bg-gray-200">
                                        <td className="p-2">Dividend Default</td>
                                        <td className="p-2">{certConfirmData.certificate.dividend_post} to Certificate</td>
                                    </tr>
                                    <tr className="bg-white">
                                        <td className="p-2">Early Withdrawal Penalty</td>
                                        <td className="p-2">{certConfirmData.certificate.penalty}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                                <br />
                                <br />
                                <a href="https://www.mymax.com/assets/files/TrkI41JU" style={{ color: 'blue' }} target="_blank" rel="noopener noreferrer">
                                    Click to View the Disclosure Package
                                </a>
                                <br />
                                <br />
                                <div>
                                    <label className="text-gray-700 text-base">
                                        <input
                                            type="checkbox"
                                            checked={agree}
                                            onChange={handleAgreeChange}
                                            style={{ marginRight: '5px' }} 
                                        />
                                        I agree to the Terms and Conditions
                                    </label>
                                    <br />
                                    <br />
                                    <button
                                        onClick={() => setIsConfirmModalOpen(true)} // Open modal on button click
                                        className={`inline-block border border-transparent rounded-full py-2 px-6 text-sm font-bold text-white text-center mt-4 ${
                                            agree ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-400 cursor-not-allowed'
                                        }`}
                                        disabled={!agree}
                                        type='button'
                                    >
                                        Create Certificate Account
                                    </button>
                                </div>
                        {isCollapsed === false ? (
                            <Popup open={confirmModal} onClose={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); }} modal nested>
                                {onClose => (
                                    <div className='modal'>
                                        {/* Common close button */}
                                        <div className="flex justify-between items-start p-2">
                                            <button 
                                                onClick={() => { onClose(); setModalStep('confirm'); getMemberData();}} 
                                                className="text-gray-600 hover:text-gray-800 text-2xl"
                                                style={{ marginLeft: 'auto', marginTop: 'auto' }}
                                                aria-label="Close"
                                            >
                                                &times;
                                            </button>
                                        </div>
                                        {/* Step 1: Confirm */}
                                        {modalStep === 'confirm' && (
                                            <>
                                        <div className='flex flex-col items-center mb-4'>
                                            <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mb-2">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="text-blue-600 w-6 h-6"
                                                    fill="currentColor"
                                                    viewBox="1.5 .4 24 26"
                                                >
                                                    <path d="M13.499 2.267c6.075 0 11 4.925 11 11 0 6.076-4.925 11-11 11s-11-4.924-11-11c0-6.075 4.925-11 11-11Zm0 2.2a8.8 8.8 0 1 0 0 17.6 8.8 8.8 0 0 0 0-17.6Zm1.1 6.6v7.7h-2.2v-7.7h2.2Zm-1.1-4.125a1.375 1.375 0 1 1 0 2.75 1.375 1.375 0 0 1 0-2.75Z" />
                                                </svg>
                                            </div>
                                            <h2 className='text-center text-2xl font-semibold'>Confirm New Product</h2>
                                        </div>
                                        <p className='text-center mb-4 text-lg text-gray-700'>You are about to open a new product on your account. Do you wish to continue? </p>
                                        <div className='actions justify-center flex mt-6'>
                                                    <button onClick={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); getMemberData();}} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" style={{ marginRight: 8 }}>
                                                No
                                            </button>
                                                    <button type='button' onClick={() => setModalStep('mfa-method')} className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition duration-200">
                                                Yes
                                            </button>
                                        </div>
                                            </>
                                        )}
                                        {/* Step 2: MFA Method Selection */}
                                        {modalStep === 'mfa-method' && (
                                            <>
                                                <div className='flex flex-col items-center mb-4'>
                                                    <h2 className='text-2xl font-semibold'>Verify Your Identity</h2>
                                                </div>
                                                <div style={{ textAlign: 'center', marginLeft: 40, marginRight: 40 }}>
                                                    To protect your information, we’ll send a one-time secure access code.<br/><br/>
                                                    Select a phone number:
                                                </div>
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 16 }}>
                                                    {phoneEntries.map(([label, phone], idx) => (
                                                        <div key={idx} style={{ marginBottom: 8 }}>
                                                            <button
                                                                type="button"
                                                                style={{
                                                                    background: '#e5e7eb',
                                                                    border: 'none',
                                                                    borderRadius: '6px',
                                                                    padding: '8px 16px',
                                                                    fontSize: '1.1rem',
                                                                    color: '#111827',
                                                                    textDecoration: 'none',
                                                                    cursor: 'pointer',
                                                                    marginBottom: '4px',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    minWidth: 200,
                                                                    width: '100%',
                                                                    maxWidth: 320,
                                                                }}
                                                                onClick={() => {
                                                                    setSelectedPhoneIndex(selectedPhoneIndex === idx ? null : idx);
                                                                    setSelectedMfaMethod('');
                                                                }}
                                                            >
                                                                {maskPhoneNumber(phone.replace(/\D/g, ''))}
                                                                {/* Optionally show label: {label} */}
                                                                {selectedPhoneIndex === idx && (
                                                                <div style={{ marginTop: 8, marginLeft: 0, display: 'flex', gap: '12px' }}>
                                                                    <button
                                                                        type="button"
                                                                        onClick={(e) => {
                                                                            handleSendSACCode('sms');
                                                                            setMfaMethod('sms');
                                                                            e.stopPropagation();
                                                                        }}
                                                                        style={{
                                                                            padding: '8px 16px',
                                                                            backgroundColor: selectedMfaMethod === 'sms' ? '#0078D4' : '#f3f2f1',
                                                                            color: selectedMfaMethod === 'sms' ? '#ffffff' : '#000000',
                                                                            border: '1px solid #ccc',
                                                                            borderRadius: '4px',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                        >
                                                                        SMS Text
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        onClick={(e) => {
                                                                            handleSendSACCode('call');
                                                                            setMfaMethod('call');
                                                                            e.stopPropagation();
                                                                        }}
                                                                        style={{
                                                                            padding: '8px 16px',
                                                                            backgroundColor: selectedMfaMethod === 'call' ? '#0078D4' : '#f3f2f1',
                                                                            color: selectedMfaMethod === 'call' ? '#ffffff' : '#000000',
                                                                            border: '1px solid #ccc',
                                                                            borderRadius: '4px',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                        >
                                                                        Phone/Voice
                                                                    </button>
                                                                </div>
                                                                )}
                                                            </button>
                                                        </div>

                                                    ))}
                                                </div>
                                                <div style={{ textAlign: 'center', margin: '24px 40px 0 40px', color: '#b91c1c', fontWeight: 500, fontSize: '1rem' }}>
                                                    Security Reminder:<br />
                                                    Do not share this code with anyone. We will never ask you to provide your secure access code by phone, email, or text.
                                                </div>
                                                <div className='actions justify-center flex mt-6'>
                                                    <button onClick={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); }} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" style={{ marginRight: 8 }}>
                                                        Cancel
                                                    </button>
                                                    
                                                </div>
                                            </>
                                        )}
                                        {/* Step 3: MFA Code Entry */}
                                        {modalStep === 'mfa-code' && (
                                            <>
                                                <div className='flex flex-col items-center mb-4'>
                                                    <h2 className='text-2xl font-semibold'>Verify Your Identity</h2>
                                                </div>
                                                <div style={{ textAlign: 'center', margin: '0 40px 16px 40px' }}>
                                                    Please enter the 6-digit code you received to continue.
                                                </div>
                                                <div className="flex flex-col items-center space-y-4">
                                                    <input
                                                        type="text"
                                                        value={mfaCode}
                                                        onChange={e => {
                                                            // Only allow 6 digits
                                                            const val = e.target.value.replace(/\D/g, '').slice(0, 6);
                                                            setMfaCode(val);
                                                            setMfaError('');
                                                        }}
                                                        maxLength={6}
                                                        className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-32 text-lg text-center"
                                                        placeholder="6-digit code"
                                                    />
                                                    {mfaError && <div className="text-red-600">{mfaError}</div>}
                                                </div>
                                                <div style={{ textAlign: 'center', margin: '24px 40px 0 40px', color: '#b91c1c', fontWeight: 500, fontSize: '1rem' }}>
                                                    Security Reminder:<br />
                                                    Do not share this code with anyone. We will never ask you to provide your secure access code by phone, email, or text.
                                                </div>
                                                <div className='actions justify-center flex mt-6'>
                                                    <button onClick={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); setMfaCode(''); }} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" style={{ marginRight: 8 }}>
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type='button'
                                                        disabled={mfaCode.length !== 6}
                                                        onClick={handleVerifySACCode}
                                                        className={`px-6 py-2 rounded-md transition duration-200 ${mfaCode.length === 6 ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`}
                                                    >
                                                        Verify
                                                    </button>
                                                </div>
                                                <div style={{ textAlign: 'center', marginTop: 12, marginBottom: 12 }}>
                                                    Didn’t get the code? <span style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {handleSendSACCode(mfaMethod)}}>Resend Code</span><br/>
                                                    Need help? Contact us at <a href="tel:3342602600" style={{ color: 'blue', textDecoration: 'underline' }}>334.260.2600</a> or <a href="tel:18007766776" style={{ color: 'blue', textDecoration: 'underline' }}>1.800.776.6776</a>
                                                </div>
                                            </>
                                        )}
                                        <br/>
                                    </div>
                                )}
                            </Popup>
                        ) : (
                            <Popup open={confirmModal} onClose={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); }} modal nested>
                            {onClose => (
                                <div className='modal'>
                                    {/* Common close button */}
                                    <div className="flex justify-between items-start p-2">
                                        <button 
                                            onClick={() => { onClose(); setModalStep('confirm'); getMemberData();}} 
                                            className="text-gray-600 hover:text-gray-800 text-2xl"
                                            style={{ marginLeft: 'auto', marginTop: 'auto' }}
                                            aria-label="Close"
                                        >
                                            &times;
                                        </button>
                                    </div>
                                    {/* Step 1: Confirm */}
                                    {modalStep === 'confirm' && (
                                        <>
                                    <div className='flex flex-col items-center mb-4'>
                                        <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mb-2">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="text-blue-600 w-6 h-6"
                                                fill="currentColor"
                                                viewBox="1.5 .4 24 26"
                                            >
                                                <path d="M13.499 2.267c6.075 0 11 4.925 11 11 0 6.076-4.925 11-11 11s-11-4.924-11-11c0-6.075 4.925-11 11-11Zm0 2.2a8.8 8.8 0 1 0 0 17.6 8.8 8.8 0 0 0 0-17.6Zm1.1 6.6v7.7h-2.2v-7.7h2.2Zm-1.1-4.125a1.375 1.375 0 1 1 0 2.75 1.375 1.375 0 0 1 0-2.75Z" />
                                            </svg>
                                        </div>
                                        <h2 className='text-center text-2xl font-semibold'>Confirm New Product</h2>
                                    </div>
                                    <p className='text-center mb-4 text-lg text-gray-700'>You are about to open a new product on your account. Do you wish to continue? </p>
                                    <div className='actions justify-center flex mt-6'>
                                                <button onClick={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); getMemberData();}} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" style={{ marginRight: 8 }}>
                                            No
                                        </button>
                                                <button type='button' onClick={() => setModalStep('mfa-method')} className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition duration-200">
                                            Yes
                                        </button>
                                    </div>
                                        </>
                                    )}
                                    {/* Step 2: MFA Method Selection */}
                                    {modalStep === 'mfa-method' && (
                                        <>
                                            <div className='flex flex-col items-center mb-4'>
                                                <h2 className='text-2xl font-semibold'>Verify Your Identity</h2>
                                            </div>
                                            <div style={{ textAlign: 'center', marginLeft: 40, marginRight: 40 }}>
                                                To protect your information, we’ll send a one-time secure access code.<br/><br/>
                                                Select a phone number:
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 16 }}>
                                                {phoneEntries.map(([label, phone], idx) => (
                                                    <div key={idx} style={{ marginBottom: 8 }}>
                                                        <button
                                                            type="button"
                                                            style={{
                                                                background: '#e5e7eb',
                                                                border: 'none',
                                                                borderRadius: '6px',
                                                                padding: '8px 16px',
                                                                fontSize: '1.1rem',
                                                                color: '#111827',
                                                                textDecoration: 'none',
                                                                cursor: 'pointer',
                                                                marginBottom: '4px',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center',
                                                                minWidth: 200,
                                                                width: '100%',
                                                                maxWidth: 320,
                                                            }}
                                                            onClick={() => {
                                                                setSelectedPhoneIndex(selectedPhoneIndex === idx ? null : idx);
                                                                setSelectedMfaMethod('');
                                                            }}
                                                        >
                                                            {maskPhoneNumber(phone.replace(/\D/g, ''))}
                                                            {/* Optionally show label: {label} */}
                                                            {selectedPhoneIndex === idx && (
                                                            <div style={{ marginTop: 8, marginLeft: 0, display: 'flex', gap: '12px' }}>
                                                                <button
                                                                    type="button"
                                                                    onClick={(e) => {
                                                                        handleSendSACCode('sms');
                                                                        setMfaMethod('sms');
                                                                        e.stopPropagation();
                                                                    }}
                                                                    style={{
                                                                        padding: '8px 16px',
                                                                        backgroundColor: selectedMfaMethod === 'sms' ? '#0078D4' : '#f3f2f1',
                                                                        color: selectedMfaMethod === 'sms' ? '#ffffff' : '#000000',
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '4px',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                    >
                                                                    SMS Text
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={(e) => {
                                                                        handleSendSACCode('call');
                                                                        setMfaMethod('call');
                                                                        e.stopPropagation();
                                                                    }}
                                                                    style={{
                                                                        padding: '8px 16px',
                                                                        backgroundColor: selectedMfaMethod === 'call' ? '#0078D4' : '#f3f2f1',
                                                                        color: selectedMfaMethod === 'call' ? '#ffffff' : '#000000',
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '4px',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                    >
                                                                    Phone/Voice
                                                                </button>
                                                            </div>
                                                            )}
                                                        </button>
                                                    </div>

                                                ))}
                                            </div>
                                            <div style={{ textAlign: 'center', margin: '24px 40px 0 40px', color: '#b91c1c', fontWeight: 500, fontSize: '1rem' }}>
                                                Security Reminder:<br />
                                                Do not share this code with anyone. We will never ask you to provide your secure access code by phone, email, or text.
                                            </div>
                                            <div className='actions justify-center flex mt-6'>
                                                <button onClick={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); }} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" style={{ marginRight: 8 }}>
                                                    Cancel
                                                </button>
                                                
                                            </div>
                                        </>
                                    )}
                                    {/* Step 3: MFA Code Entry */}
                                    {modalStep === 'mfa-code' && (
                                        <>
                                            <div className='flex flex-col items-center mb-4'>
                                                <h2 className='text-2xl font-semibold'>Verify Your Identity</h2>
                                            </div>
                                            <div style={{ textAlign: 'center', margin: '0 40px 16px 40px' }}>
                                                Please enter the 6-digit code you received to continue.
                                            </div>
                                            <div className="flex flex-col items-center space-y-4">
                                                <input
                                                    type="text"
                                                    value={mfaCode}
                                                    onChange={e => {
                                                        // Only allow 6 digits
                                                        const val = e.target.value.replace(/\D/g, '').slice(0, 6);
                                                        setMfaCode(val);
                                                        setMfaError('');
                                                    }}
                                                    maxLength={6}
                                                    className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-32 text-lg text-center"
                                                    placeholder="6-digit code"
                                                />
                                                {mfaError && <div className="text-red-600">{mfaError}</div>}
                                            </div>
                                            <div style={{ textAlign: 'center', margin: '24px 40px 0 40px', color: '#b91c1c', fontWeight: 500, fontSize: '1rem' }}>
                                                Security Reminder:<br />
                                                Do not share this code with anyone. We will never ask you to provide your secure access code by phone, email, or text.
                                            </div>
                                            <div className='actions justify-center flex mt-6'>
                                                <button onClick={() => { setIsConfirmModalOpen(false); setModalStep('confirm'); setMfaCode(''); }} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200" style={{ marginRight: 8 }}>
                                                    Cancel
                                                </button>
                                                <button
                                                    type='button'
                                                    disabled={mfaCode.length !== 6}
                                                    onClick={handleVerifySACCode}
                                                    className={`px-6 py-2 rounded-md transition duration-200 ${mfaCode.length === 6 ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`}
                                                >
                                                    Verify
                                                </button>
                                            </div>
                                            <div style={{ textAlign: 'center', marginTop: 12, marginBottom: 12 }}>
                                                Didn’t get the code? <span style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => {handleSendSACCode(mfaMethod)}}>Resend Code</span><br/>
                                                Need help? Contact us at <a href="tel:3342602600" style={{ color: 'blue', textDecoration: 'underline' }}>334.260.2600</a> or <a href="tel:18007766776" style={{ color: 'blue', textDecoration: 'underline' }}>1.800.776.6776</a>
                                            </div>
                                        </>
                                    )}
                                    <br/>
                                </div>
                            )}
                            </Popup>
                        )}
                    </div>
                ) : message.type==='successSubmit'? (
                    //xsell_spend
                    <div className="flex-grow flex flex-col items-center justify-center space-y-4">
                        <h1><strong>CONGRATULATIONS!</strong></h1>
                        <h2>Your certificate has been created!</h2> 
                        <h2>{certSubmitData.certificate.name} : Opening Balance :{certSubmitData.certificate.deposit}</h2>
                        {certSubmitData.xsell_spend === 'YES' && ( 
                            
                            <div className="flex-grow flex flex-col text-center items-center justify-center pt-24 space-y-8">
                                <p>But wait!</p>
                                <br/>
                                <p>Here are some other products you can take advantage of with your MAX membership!</p>
                                <br/>
                                <div className="roundedGreyCard">
                                    <h3 className="text-lg font-bold">SPEND ACCOUNT.</h3>
                                    <p>You don't currently have a spend account with us, click <strong>Open</strong> below to get started!</p>
                                    <br/>
                                    <button onClick={() => navigate('/addchk')} className="inline-block bg-blue-600 border border-transparent rounded-full py-1 px-6 text-sm font-bold text-white text-center hover:bg-blue-700">
                                        Open
                                    </button>
                                </div>
                            </div>
                        )}
                    </div> 
                ) : (
                    <div>
                        <p>error</p>  
                    </div>
                )
            ):(
                <form className="flex-grow flex flex-col items-center justify-center pt-24 space-y-8">
                    <div className="flex-grow flex flex-col items-center justify-center pt-24 space-y-8">
                        <div className="flex flex-col items-center space-y-4">
                        {/* Transfer Funds Dropdown */}
                        <label htmlFor="certOpt" className="text-gray-700 text-base">
                            Select an option below
                        </label>
                        
                        <select
                            id="certOpt"
                            value={certOption}
                            onChange={(e) => 
                                {
                                    handleCertOption(e);
                                }
                            }
                            className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[400px] text-lg"
                        >
                            <option value="null"></option>
                            {Object.entries(certData.certificates).map(([key, data], index) => (
                                <option key={data.type} value={index + 1 +"."+data.type}>
                                    {data.name}
                                </option>
                            ))}
                        </select>
                        {Object.entries(certData.certificates).map(([key ,data], index) => (
                            certOption.split('.')[1] === data.type && (
                                <div className="flex-grow flex flex-col items-center justify-center">
                                    <h1 key={data.type} className="px-4 py-3"><strong>Minimum Opening Balance: ${data.min_opening_balance_str}</strong></h1>
                                    <h2>Rate: {data.apy}% APY</h2>
                                </div>
                            )
                        ))}
                        
                        <label htmlFor="depositAmount" className="text-gray-700 text-base">
                            How much would you like to deposit?
                        </label>
                        <div className="flex w-full max-w-[400px]">
                            <div className="flex items-center justify-center px-4 bg-gray-100 border border-gray-300 rounded-md">
                                <span className="text-gray-600" style={{ fontSize: '1.125rem', lineHeight: '1.75rem' }}>$</span>
                            </div>
                            <input
                                type="text"
                                id="depositAmount"
                                value={amount}
                                onChange={handleAmountChange}
                                ref={depositAmountRef}
                                onFocus={handleDepositAmountFocus}
                                onBlur={handleBlur} // Apply .00 on blur
                                className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[400px] text-lg"
                                placeholder="0.00"
                                style={{ fontSize: '1.125rem', lineHeight: '1.75rem' }}
                            />
                        </div>

                        <label htmlFor="transferFunds" className="text-gray-700 text-base">
                            Transfer Funds From
                        </label>
                        
                        <select
                            id="transferFunds"
                            value={certTransferFunds}
                            onChange={(e) => 
                                {
                                    handleCertTransferFunds(e);
                                }
                            }
                            className="px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 w-full max-w-[400px] text-lg"
                        >
                            <option value="null">Select an account</option>
                            {Object.entries(certData.shares).map(([key, data], index) => (
                                <option key={data.share_id} value={index + 1 + '.' + data.share_available_balance}>
                                    {data.share_id} - {data.share_description} (${data.share_available_balance_str})
                                </option>
                            ))}
                        </select>
                        <br/>
                        <h2>You must select a share with an available balance higher than the amount you want to deposit.</h2>
                        <button
                            onClick={() => {
                                handleAdequateFunds();
                            }

                            } // Open modal on button click
                            className={`inline-block border border-transparent rounded-full py-2 px-6 text-sm font-bold text-white text-center mt-4 ${
                                certOption === 'null' || amount === '0.00' || certTransferFunds === 'null' 
                                    ? 'bg-gray-400 cursor-not-allowed' // Disabled state
                                    : 'bg-blue-600 hover:bg-blue-700' // Enabled state
                            }`}
                            disabled={certOption === 'null' || amount === '0.00' || certTransferFunds === 'null'} // Updated condition
                            type='button'
                        >
                            Create Certificate Account
                        </button>      
                        </div>                  
                        <Popup open={minBalModal} onClose={() => setIsMinBalModalOpen(false)} modal nested>
                            {close => (
                                <div className='modal'>
                                    

                                    <div className="flex justify-between items-start p-2">
                                        <button 
                                            onClick={close} 
                                            className="text-gray-600 hover:text-gray-800 text-2xl"
                                            style={{ marginLeft: 'auto', marginTop: 'auto' }}
                                            aria-label="Close"
                                        >
                                            &times;
                                        </button>
                                    </div>
                                    <div className='flex flex-col items-center mb-4'>
                                        <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mb-2">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="text-red-600 w-6 h-6"
                                                fill="currentColor"
                                                viewBox="1.5 .4 24 26"
                                            >
                                                <path d="M13.499 2.267c6.075 0 11 4.925 11 11 0 6.076-4.925 11-11 11s-11-4.924-11-11c0-6.075 4.925-11 11-11Zm0 2.2a8.8 8.8 0 1 0 0 17.6 8.8 8.8 0 0 0 0-17.6Zm1.1 6.6v7.7h-2.2v-7.7h2.2Zm-1.1-4.125a1.375 1.375 0 1 1 0 2.75 1.375 1.375 0 0 1 0-2.75Z" />
                                            </svg>
                                            
                                        </div>
                                        <h2 className='text-2xl font-semibold'>Not Enough Deposit Amount</h2>
                                    </div>
                                    <p className='text-center mb-4 text-lg text-gray-700'>Please increase your deposit amount to be equal to or higher than Minimum Balance.</p>
                                    <div className='actions justify-center flex space-x-6 mt-6'>
                                        <button onClick={() => setIsMinBalModalOpen(false)} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200">
                                            Close
                                        </button>
                                    </div>
                                    <br/>
                                </div>
                            )}
                        </Popup>
                        <Popup open={nsfModal} onClose={() => setIsNsfModalOpen(false)} modal nested>
                            {close => (
                                <div className='modal'>
                                    

                                    <div className="flex justify-between items-start p-2">
                                        <button 
                                            onClick={close} 
                                            className="text-gray-600 hover:text-gray-800 text-2xl"
                                            style={{ marginLeft: 'auto', marginTop: 'auto' }}
                                            aria-label="Close"
                                        >
                                            &times;
                                        </button>
                                    </div>
                                    <div className='flex flex-col items-center mb-4'>
                                        <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mb-2">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="text-red-600 w-6 h-6"
                                                fill="currentColor"
                                                viewBox="1.5 .4 24 26"
                                            >
                                                <path d="M13.499 2.267c6.075 0 11 4.925 11 11 0 6.076-4.925 11-11 11s-11-4.924-11-11c0-6.075 4.925-11 11-11Zm0 2.2a8.8 8.8 0 1 0 0 17.6 8.8 8.8 0 0 0 0-17.6Zm1.1 6.6v7.7h-2.2v-7.7h2.2Zm-1.1-4.125a1.375 1.375 0 1 1 0 2.75 1.375 1.375 0 0 1 0-2.75Z" />
                                            </svg>
                                            
                                        </div>
                                        <h2 className='text-2xl font-semibold'>Insufficient Funds</h2>
                                    </div>
                                    <p className='text-center mb-4 text-lg text-gray-700'>You do not have sufficient funds in the selected share. Please select a different share with sufficient funds.</p>
                                    <div className='actions justify-center flex space-x-6 mt-6'>
                                        <button onClick={() => setIsNsfModalOpen(false)} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200">
                                            Close
                                        </button>
                                    </div>
                                    <br/>
                                </div>
                            )}
                        </Popup>
                        <Popup open={bothModal} onClose={() => setIsBothModalOpen(false)} modal nested>
                            {close => (
                                <div className='modal'>
                                    

                                    <div className="flex justify-between items-start p-2">
                                        <button 
                                            onClick={close} 
                                            className="text-gray-600 hover:text-gray-800 text-2xl"
                                            style={{ marginLeft: 'auto', marginTop: 'auto' }}
                                            aria-label="Close"
                                        >
                                            &times;
                                        </button>
                                    </div>
                                    <div className='flex flex-col items-center mb-4'>
                                        <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mb-2">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="text-red-600 w-6 h-6"
                                                fill="currentColor"
                                                viewBox="1.5 .4 24 26"
                                            >
                                                <path d="M13.499 2.267c6.075 0 11 4.925 11 11 0 6.076-4.925 11-11 11s-11-4.924-11-11c0-6.075 4.925-11 11-11Zm0 2.2a8.8 8.8 0 1 0 0 17.6 8.8 8.8 0 0 0 0-17.6Zm1.1 6.6v7.7h-2.2v-7.7h2.2Zm-1.1-4.125a1.375 1.375 0 1 1 0 2.75 1.375 1.375 0 0 1 0-2.75Z" />
                                            </svg>
                                            
                                        </div>
                                        <h2 className='text-2xl font-semibold'>Insufficient Funds and Not Enough Deposit Amount</h2>
                                    </div>
                                    <p className='text-center mb-4 text-lg text-gray-700'>You do not have sufficient funds in the selected share and Minimum Balance were not met. Please select a different share with sufficient funds and increase the Deposit amount.</p>
                                    <div className='actions justify-center flex space-x-6 mt-6'>
                                        <button onClick={() => setIsBothModalOpen(false)} className="bg-gray-300 px-6 py-2 rounded-md hover:bg-gray-400 transition duration-200">
                                            Close
                                        </button>
                                    </div>
                                    <br/>
                                </div>
                            )}
                        </Popup>
                    </div>
                </form>    
            )}
        
        
        </div>    
        </div>
    );
}

export default AddCert;
